/**
 * @description {查询 相关接口 }
 */
import { api } from '@/utils/http'

const QUERY_SKU = '/query/sku'
const QUERY_ARTICLE = '/query/article'

export function querySku(data){
    return api({url:QUERY_SKU, method:'POST', data})
}

export function queryArticle(data){
    return api({url:QUERY_ARTICLE, method:'POST', data})
}